import React, { useCallback, useEffect, useState } from 'react';

import { FormPlanejamento } from '../../components/FormPlanejamento';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';
import MenuMain from '../../MenuMain';

import { AppFooter } from '../../AppFooter';

import api from '../../api/api';

export default function EditarPlanejamentoPage(props) {

    const [planejamentos, setPlanejamentos] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errorGettingPlanejamentos, setErrorGettingPlanejamentos] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [idPlanejamento] = useState(props.match.params.id)


    const getPlanejamentos = useCallback(async () => {
        setIsLoading(true);

        try {
            const response = await api.get(`planejamento/${idPlanejamento}`)            
            
            setPlanejamentos(response.data);

            setErrorGettingPlanejamentos(false)
        }
        catch (error) {
            setErrorMessage(error.toString())
            setErrorGettingPlanejamentos(true)
        }

        setIsLoading(false);
    }, [idPlanejamento]);

    useEffect(() => {

        async function planejamentos() {
            await getPlanejamentos();
        };
        planejamentos();

    }, [getPlanejamentos])

    return (
        <>
            <MenuMain >
                {
                    errorGettingPlanejamentos ?
                        <ErrorRetrievingData
                            errorMessage={errorMessage}
                            retrieveFunction={() => getPlanejamentos(idPlanejamento)}
                            isLoading={isLoading}
                        />
                        :
                        <FormPlanejamento
                            defaultValues={planejamentos}
                            isEditing={true}
                            isLoading={isLoading}
                        />
                }
            </MenuMain>
            <AppFooter />
        </>
    );
}